import { Enums } from '@bode-canada/core';

const { PropertyTypeEnum, BuildingClassEnum } = Enums;

// eslint-disable-next-line import/prefer-default-export
export const SEARCH_BUILDING_CLASSES = [
  BuildingClassEnum.DETACHED,
  PropertyTypeEnum.ATTACHED,
  BuildingClassEnum.APARTMENT,
  BuildingClassEnum.VACANT_LAND,
];
